class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    const iconsearch = document.querySelector(".header__search");
    if (iconsearch)
      iconsearch.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    const iconaccount = document.querySelector(".header__icon--account");
    if (iconaccount)
      iconaccount.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    this.stickyHeaderAvailable = document.querySelector('sticky-header') ? true : false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    // if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      // this.open(cartLink);
      this.classList.contains("active") ? this.close() : this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  closeHeaderDrawers() {
    if (typeof window.bzCloseHeaderMenus === 'function') {
      window.bzCloseHeaderMenus();
    } else {
      document.querySelectorAll('.header-wrapper header-menu details').forEach((details) => {
        details.classList.remove('menu-opening', 'closing');
        details.removeAttribute('open');
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('menu_open', 'menu_opening');
    }
    const drawers = document.querySelectorAll(
      'header-layer, .section-header menu-drawer, .header-wrapper menu-drawer'
    );
    let closedAny = false;

    drawers.forEach((drawer) => {
      const details = drawer.querySelector('details.menu-drawer-container') || drawer.querySelector('details');
      if (!details) return;
      // only act on a drawer that is actually visible (not one mid close-animation)
      if (!details.hasAttribute('open') || !details.classList.contains('menu-opening')) return;

      const summary = details.querySelector('summary');
      const focusTarget = document.querySelector('#cart-icon-bubble') || summary;
      closedAny = true;

      if (typeof drawer.closeMenuDrawer === 'function') {
        // both guards need a defined event AND a truthy elementToFocus
        drawer.closeMenuDrawer(new Event('cart:open'), focusTarget);
      } else {
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
      }

      details.querySelectorAll('summary[aria-expanded="true"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });
    });

    if (!closedAny) return;

    // safety net for leftover body / header state
    document.body.classList.remove(
      'menu_drawer_overlay',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
    document.querySelector('.section-header')?.classList.remove('menu-open');
  }

  open(triggeredBy) {
     this.closeHeaderDrawers();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    const headerMain = document.querySelector('.header-wrapper');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('cart_active');
    });
        this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
  }

  close() {
    const headerMain = document.querySelector('.header-wrapper');
    this.classList.remove('active');
    document.body.classList.remove('cart_active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // The drawer markup differs when the cart is empty, so none of these pieces
    // can be assumed to exist: a missing one must skip that step, not throw after
    // the item has already been added.
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];

      if (!sectionElement || !html) return;
      const inner = this.getSectionInnerHTML(html, section.selector);
      if (inner !== null) sectionElement.innerHTML = inner;
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);